<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="300px">
                <v-card>
                    <v-card-title>
                        <span class="headline">
                            {{ title }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form
                                ref="form"
                                lazy-validation>
                                    <v-text-field 
                                        :label="$vuetify.lang.t('$vuetify.systemManage.permission.table.name')" 
                                        v-model="data.name"
                                        :rules="rules.name" 
                                        outlined
                                        required
                                    ></v-text-field>
                                    <v-textarea
                                        outlined
                                        name="input-7-4"
                                        :label="$vuetify.lang.t('$vuetify.systemManage.permission.table.router')" 
                                        v-model="data.apis"
                                        :rules="rules.apis" 
                                    ></v-textarea>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="handleClose">
                            {{$vuetify.lang.t('$vuetify.systemManage.close')}}
                        </v-btn>
                        <v-btn color="primary" @click="handleUpdate" :loading="loading">
                            {{$vuetify.lang.t('$vuetify.systemManage.update')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import * as api from '../../../api'
import { Notification } from 'element-ui';

export default {

    data () {
        return {

            title: this.$vuetify.lang.t('$vuetify.systemManage.permission.editBtn'),

            dialog: false,

            loading: false,

            data: {
                name: null,
                apis: null
            },

            rules: {
                name: [
                    value => this.formSpaces(value)!='' || this.$vuetify.lang.t('$vuetify.systemManage.permission.rules.name'),
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.systemManage.permission.rules.name')
                ],
                apis: [
                    value => this.formSpaces(value)!='' || this.$vuetify.lang.t('$vuetify.systemManage.permission.rules.router'),
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.systemManage.permission.rules.router')
                ]
            }
            
        }
    },

    methods: {

        formSpaces(str){
            if(str !== null && str !== undefined){
                let res = str.replace(/\s*/g,'')
                return res;
            }
        },

        handleOpen (item) {
            this.data = this.newObject(item);
            this.data.apis = this.data.apis.join("\n");
            this.dialog = true;
        },

        handleClose () {
            this.dialog = false;
            this.$refs.form.reset();
        },

        handleUpdate () {
            if (this.$refs.form.validate()) {
                this.loading = true;
                var temp = this.data.apis.split("\n");
                this.data.apis = temp.join(",");
                this.$http.post(api.default.system.permissionEditUrl, this.data).then(resp => {
                    // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                    if (!resp) return;
                    Notification({
                        type: 'success',
                        message: this.$vuetify.lang.t('$vuetify.userManage.success')
                    });
                    this.$emit('handleSearch');
                }).finally(resp => {
                    this.loading = false;
                    this.handleClose();
                })
            }
        },

        newObject (item) {
            var data = JSON.stringify(item);
            return JSON.parse(data)
        }

    }
}
</script>

<style scoped>



</style>